import { useLazyQuery } from "@apollo/client";
import { ProductIdByStockNumberResult } from "@towersystems/roam-common/lib/generated-types";
import { useCallback } from "react";
import { PRODUCT_ID_BY_STOCK_NUMBER_QUERY } from "./constants";

export function useProductIdByStockNumberQuery() {
  const [query] = useLazyQuery<{
    productIdByStockNumber: ProductIdByStockNumberResult;
  }>(PRODUCT_ID_BY_STOCK_NUMBER_QUERY);

  const getProductIdByStockNumber = useCallback(async (stockNumber: string) => {
    const res = await query({
      variables: {
        stockNumber,
      },
    });
    const productId = res.data?.productIdByStockNumber;
    if (!productId) {
      throw new Error(`error.unexpected-failure`);
    }
    return productId;
  }, []);

  return {
    getProductIdByStockNumber,
  };
}
